module.exports = __webpack_public_path__ + "img/SHIPPING.93e61226.svg";